import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// lodash
import get from 'lodash/get';
// jl-design-system
import { TertiaryButton } from 'jl-design-system/elements/button/Button';
import ChevronRightRegular from 'jl-design-system/elements/icons/ChevronRightRegular';
// classnames
import classNames from 'classnames';
// components
import { getFormId } from '../../utils/form/configs/itemQuantity';
import { showEditBasketModal } from '../../redux/actions/edit-basket/editBasketActions';
import { triggerExpandBasketButtonClickedAnalytics } from '../../redux/actions/app/appActions';
import OrderItem from '../order-item/OrderItem';
import TradeInDetails from '../trade-in-details/TradeInDetails';
// styles
import styles from './order-summary.scss';

const itemsNeededToEnableExpander = 3;
const spaceNeededForToggleButton = 70;

export class OrderSummary extends PureComponent {

  static propTypes = {
    collapsed: PropTypes.bool,
    displayHeaders: PropTypes.bool,
    forcedReducedQuantity: PropTypes.number,
    form: PropTypes.shape({}),
    getDeliveryMethodsApiCallActive: PropTypes.bool,
    hideChildItems: PropTypes.bool,
    hideEditBasket: PropTypes.bool,
    hideOutOfStockText: PropTypes.bool,
    hideQuantities: PropTypes.bool,
    hideSubtotals: PropTypes.bool,
    initPaymentPageCallActive: PropTypes.bool,
    isMultiBatch: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    modalView: PropTypes.bool,
    partnerDiscountEnabled: PropTypes.bool,
    pathname: PropTypes.string,
    paymentProcessing: PropTypes.bool,
    preventEditing: PropTypes.bool,
    proceedingToPayment: PropTypes.bool,
    putDeliveryAddressApiCallActive: PropTypes.bool,
    showEditBasketModal: PropTypes.func,
    showReducedQuantityDetails: PropTypes.bool,
    showTradeInBoxInOrderConfirmation: PropTypes.bool,
    sidebarView: PropTypes.bool,
    tradeInQuotes: PropTypes.arrayOf(PropTypes.shape({
      deviceName: PropTypes.string,
      payment: PropTypes.shape({
        amount: PropTypes.string,
      }),
    })),
    triggerExpandBasketButtonClickedAnalytics: PropTypes.func,
  };

  static defaultProps = {
    collapsed: false,
    displayHeaders: true,
    forcedReducedQuantity: undefined,
    form: undefined,
    getDeliveryMethodsApiCallActive: false,
    hideChildItems: false,
    hideEditBasket: false,
    hideOutOfStockText: false,
    hideQuantities: false,
    hideSubtotals: false,
    initPaymentPageCallActive: false,
    isMultiBatch: false,
    items: [],
    modalView: false,
    partnerDiscountEnabled: false,
    pathname: '',
    paymentProcessing: false,
    preventEditing: false,
    proceedingToPayment: false,
    putDeliveryAddressApiCallActive: false,
    showEditBasketModal: window.defaultFunc,
    showReducedQuantityDetails: false,
    showTradeInBoxInOrderConfirmation: false,
    sidebarView: false,
    tradeInQuotes: [],
    triggerExpandBasketButtonClickedAnalytics: window.defaultFunc,
  };

  constructor() {
    super();
    this.state = {
      expanded: false,
    };
  }

  componentDidMount() {
    this.setInlineHeightStyles();
  }

  componentDidUpdate() {
    this.setInlineHeightStyles();
  }

  handleShowEditBasketModalClick = () => {
    const { pathname, showEditBasketModal } = this.props;

    showEditBasketModal(pathname);
  };

  setInlineHeightStyles = () => {
    const { collapsed } = this.props;

    if (this.el && this.el.querySelectorAll && !collapsed) {
      const orderSummaryItems = this.el.querySelectorAll('[data-index^="order-summary-item"]');

      if (orderSummaryItems.length >= itemsNeededToEnableExpander) {
        if (!this.state.expanded) {
          const heightContracted = orderSummaryItems[0].clientHeight + orderSummaryItems[1].clientHeight;
          this.setContainerHeight(heightContracted);
        } else {
          let heightExpanded = spaceNeededForToggleButton;
          for (let i = 0; i < orderSummaryItems.length; i += 1) {
            heightExpanded += orderSummaryItems[i].clientHeight;
          }
          this.setContainerHeight(heightExpanded);
        }
      } else {
        this.removeContainerHeight();
      }
    }
  };

  getContainerElement = () => this.el.querySelector('[data-test="order-summary-item-container"]');

  removeContainerHeight = () => {
    const containerElement = this.getContainerElement();
    containerElement.style.removeProperty('height');
  };

  setContainerHeight = (height) => {
    const containerElement = this.getContainerElement();
    containerElement.style.height = `${height}px`;
  };

  setExpandToggleState = () => {
    const { triggerExpandBasketButtonClickedAnalytics } = this.props;
    const isExpanded = this.state.expanded;
    this.setState({
      expanded: !isExpanded,
    });

    if (!isExpanded) {
      triggerExpandBasketButtonClickedAnalytics();
    }
  };

  renderExpandToggle = (totalRenderedItems) => {
    if (totalRenderedItems >= itemsNeededToEnableExpander) {
      return (
        <div className={styles.expandToggleContainer}>
          <button
            className={styles.expandToggleButton}
            onClick={this.setExpandToggleState}
            type="button"
          >
            <span data-test="show-item-button">{this.state.expanded ? 'Show less' : 'Show more items'}</span>
          </button>
        </div>
      );
    }

    return null;
  };

  disableEditButton = () => {
    const {
      initPaymentPageCallActive,
      putDeliveryAddressApiCallActive,
      proceedingToPayment,
      getDeliveryMethodsApiCallActive,
      paymentProcessing,
    } = this.props;

    return initPaymentPageCallActive ||
      putDeliveryAddressApiCallActive ||
      proceedingToPayment ||
      getDeliveryMethodsApiCallActive ||
      paymentProcessing;
  };

  render() {
    const {
      collapsed,
      displayHeaders,
      items,
      sidebarView,
      partnerDiscountEnabled,
      hideChildItems,
      hideSubtotals,
      hideQuantities,
      showReducedQuantityDetails,
      forcedReducedQuantity,
      hideOutOfStockText,
      modalView,
      preventEditing,
      form,
      hideEditBasket,
      tradeInQuotes,
      showTradeInBoxInOrderConfirmation,
      isMultiBatch,
    } = this.props;

    let totalQuantity = 0;
    let totalRenderedItems = 0;

    const orderItems = items.map((item = {}) => {
      const isItemFabric = item.uom !== '';
      totalRenderedItems += 1;

      if (!isItemFabric) {
        totalQuantity += item.quantity;
      } else {
        totalQuantity += 1;
      }

      const reducedQuantity = showReducedQuantityDetails ? forcedReducedQuantity || item.stockLevel : undefined;

      return (
        <div key={item.id} className={styles.itemContainer} data-index={`order-summary-item-${totalQuantity}`} data-test="order-summary-item">
          <OrderItem
            displayImage={!!item.imageUrl}
            hideOutOfStockText={hideOutOfStockText}
            hideQuantities={hideQuantities}
            hideSubtotals={hideSubtotals}
            modal={modalView}
            partnerDiscountEnabled={partnerDiscountEnabled}
            reducedQuantity={reducedQuantity}
            removeItem={this.handleShowEditBasketModalClick}
            sidebar={sidebarView}
            {...item}
          />
          {
            !hideChildItems &&
            !!item.childItems?.length &&
            item.childItems.map((childItem = {}, index) => {
              const selectedParentQuantity = get(form, `${getFormId(item.id)}.values.itemQuantity`, reducedQuantity);
              const childItemReducedQuantity = selectedParentQuantity < childItem.quantity ? selectedParentQuantity :
                undefined;
              const parsedReducedQuantity = childItemReducedQuantity ? parseInt(childItemReducedQuantity, 10) :
                undefined;

              totalQuantity += childItem.quantity;

              return (
                <div key={childItem.id}>
                  {
                    sidebarView && index === 0 &&
                    <p>Additional services</p>
                  }
                  <OrderItem
                    child
                    displayImage={false}
                    hideQuantities={hideQuantities}
                    hideSubtotals={hideSubtotals}
                    modal={modalView}
                    preventEditing={preventEditing}
                    reducedQuantity={parsedReducedQuantity}
                    sidebar={sidebarView}
                    {...childItem}
                  />
                </div>
              );
            })
          }
        </div>
      );

    });

    const containerShouldBeContracted = !this.state.expanded && totalRenderedItems >= itemsNeededToEnableExpander;
    const containerShouldBeExpanded = this.state.expanded && totalRenderedItems >= itemsNeededToEnableExpander;
    const enableScrollableContainer = containerShouldBeContracted && sidebarView;

    const itemsContainerClassnames = classNames(styles.items, {
      [styles.itemContainerContracted]: containerShouldBeContracted,
      [styles.itemContainerExpanded]: containerShouldBeExpanded,
      [styles.scrollBar]: enableScrollableContainer,
    });

    totalQuantity += tradeInQuotes.length;

    const heading = totalQuantity === 1 ?
      '(1 item)' :
      `(${totalQuantity} items)`;

    const headingId = 'order-summary-heading';

    const editBasketProps = {
      'aria-describedby': headingId,
      'data-test': 'edit-basket-button',
      disabled: this.disableEditButton(),
      onClick: this.handleShowEditBasketModalClick,
      size: 'small',
    };

    const containerClassnames = classNames(styles.container, {
      [styles.containerCollapsed]: collapsed,
    });

    return (
      <div
        ref={(el) => { this.el = el; }}
        className={containerClassnames}
        data-test="order-summary-container"
      >
        {
          displayHeaders &&
          <div className={styles.sidebarHeading}>
            <h2
              className={styles.headingTitle}
              data-test="order-summary-header"
              id={headingId}
            >
              Basket <span>{heading}</span>
            </h2>
            {
              !hideEditBasket &&
              <TertiaryButton
                {...editBasketProps}
                className={styles.editBasketButton}
                IconComponent={ChevronRightRegular}
                small
              >
                { collapsed ? 'View' : 'Edit' }
              </TertiaryButton>
            }
          </div>
        }

        {
          !collapsed &&
          <>
            {
              !isMultiBatch &&
              <TradeInDetails
                showTradeInBoxInOrderConfirmation={showTradeInBoxInOrderConfirmation}
                tradeInItems={tradeInQuotes}
              />
            }
            <div className={styles.itemContainerWrapper}>
              <div
                className={itemsContainerClassnames}
                data-test="order-summary-item-container"
              >
                {orderItems}
                {
                  !enableScrollableContainer &&
                  this.renderExpandToggle(totalRenderedItems)
                }
              </div>
              {
                enableScrollableContainer &&
                <div className={styles.fade} data-test="scrollbar-fade" />
              }
            </div>
          </>
        }
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    pathname: get(state, 'router.location.pathname', ''),
    initPaymentPageCallActive: state.payment.initPaymentPageCallActive,
    putDeliveryAddressApiCallActive: state.delivery.putDeliveryAddressApiCallActive,
    proceedingToPayment: state.delivery.proceedingToPayment,
    getDeliveryMethodsApiCallActive: state.delivery.getDeliveryMethodsApiCallActive,
    paymentProcessing: state.payment.paymentProcessing,
    tradeInQuotes: get(state, 'orderForm.tradeInQuotes'),
    showTradeInBoxInOrderConfirmation: get(state, 'confirmation.showTradeInBoxInOrderConfirmation', false),
  };
}

export function mapDispatchToProps() {
  return {
    showEditBasketModal,
    triggerExpandBasketButtonClickedAnalytics,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(OrderSummary);
